module.exports = __webpack_public_path__ + "img/chadle1_2.1e3294d1.png";